import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

// Bug A fix (Pre-EAS sprint): the SPA kept the previous page's scroll
// position on PUSH navigation (listing detail → heatmap opened
// half-scrolled / cut off). POP (back/forward) keeps the browser's
// native scroll restore.
export default function ScrollToTop() {
  const { pathname } = useLocation();
  const navType = useNavigationType();
  useEffect(() => {
    if (navType !== "POP") window.scrollTo(0, 0);
  }, [pathname, navType]);
  return null;
}
